<div class="c-slotcardInfo">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-slotcardInfo__container">
    <span class="text title">{{ 'home.live-ops.slotcard.modal-info.title' | translate }}</span>

    <div class="c-slotcardInfo__explanation">
      <div class="explanation">
        <div class="image image-1"></div>
        @if ((slotcardMinPurchase | number) != 0) {
          <div class="min-purchase">
            <span class="text"
              >{{ 'home.live-ops.slotcard.min-purchase' | translate }} {{ slotcardMinPurchase }}
              {{ slotcardCurrencySymbol }}</span
            >
          </div>
        }
        <span class="text subtitle">{{ 'home.live-ops.slotcard.modal-info.step-1' | translate }}</span>
      </div>

      <div class="arrow arrow-1"></div>

      <div class="explanation">
        <div class="image image-2"></div>
        @if (slotcard.properties.extrarewardpercentage != 0) {
          <div class="extra-percent">
            <span class="text percent">{{ slotcard.properties.extrarewardpercentage }}&#37;</span>
            <span class="text extra">{{ 'home.live-ops.slotcard.extra' | translate }}</span>
          </div>
        }
        <span class="text subtitle">{{ 'home.live-ops.slotcard.modal-start.title' | translate }}</span>
      </div>

      <div class="arrow arrow-2"></div>

      <div class="explanation">
        <div class="image image-3"></div>
        <span class="text subtitle">{{ 'home.live-ops.slotcard.modal-start.subtitle' | translate }}</span>
      </div>
    </div>
  </div>
</div>
